// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__34w3e","buttons":"PendingPaymentAlert_buttons__2sx-d"};